import React from "react";
import {
	Button,
	Card,
	CardBody,
	Container,
	CardHeader,
	Input,
	toast,
	MDBIcon,
} from "mdbreact";
import ContactTypeService from "./contactTypesService";
import { ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";

export default class addContactType extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: "",
			errorMessage: "",
		};
	}

	nameChange = (e) => {
		this.setState({
			name: e.target.value,
		});
	};

	renderAddContactButton() {
		return (
			<div>
				<p style={{ color: "red" }}>{this.state.errorMessage}</p>
				<Input
					label={"Contact Type Name"}
					onChange={this.nameChange.bind(this)}
					value={this.state.name}
				/>
			</div>
		);
	}

	addSaveButtonClick = () => {
		if (this.validate()) {
			let obj = {
				name: this.state.name,
			};
			return ContactTypeService.createContactType(obj)
				.then((res) => {
					this.setState({
						errorMessage: "",
						name: "",
					});
					toast.success(obj.name + " Contact Type has been Added!");
				})
				.catch((err) => {
					toast.warn("An error occurred adding a new Contact Type");
				});
		}
	};

	validate() {
		let n = this.state.name;
		if (n === "") {
			this.setError("Please enter a Contact Name");
			return false;
		}
		return true;
	}
	setError(e) {
		this.setState({
			errorMessage: e,
		});
	}

	render() {
		return (
			<div>
				<ToastContainer
					hideProgressBar={false}
					newestOnTop={true}
					autoClose={3000}
				/>
				<Container className="mt-5">
					<Card>
						<CardHeader
							color={"blue-grey lighten-2"}
							style={{ textAlign: "center" }}
						>
							<Button
								style={{ float: "left" }}
								floating
								size="sm"
								color={"warning"}
								data-tip={"Back to Contact Types"}
								onClick={() => this.props.history.push("/contactTypes")}
							>
								<MDBIcon icon="backward" style={{ fontSize: "2em" }} />
							</Button>
							Add New Contact Type
							<Button
								style={{ float: "right" }}
								floating
								size="sm"
								color={"success"}
								data-tip={"Save New Contact Type"}
								onClick={this.addSaveButtonClick}
							>
								<MDBIcon far icon="save" style={{ fontSize: "2em" }} />
							</Button>
						</CardHeader>

						<CardBody>{this.renderAddContactButton()}</CardBody>
					</Card>
					<ReactTooltip />
				</Container>
			</div>
		);
	}
}
